import Main from '@/pages/Main'
import merchartRegist from './merchartRegist'
// 不作为Main组件的子页面展示的页面单独写，如下
export const page404 = {
  path: '/*',
  name: 'error-404',
  meta: {
    title: '404-页面不存在',
  },
  component: () => import('../pages/error/404.vue'),
}

export const page403 = {
  path: '/403',
  meta: {
    title: '403-权限不足',
  },
  name: 'error-403',
  component: () => import('../pages/error/403.vue'),
}

export const page500 = {
  path: '/500',
  meta: {
    title: '500-服务端错误',
  },
  name: 'error-500',
  component: () => import('../pages/error/500.vue'),
}

import shop from "./shop"; //商品信息
import system from "./system"; //系统设置
import user from "./user"; //系统设置
import bus from "./bus"; //系统设置
import oper from "./oper"; //系统设置
import activity from "./activity.js"; //活动设置
import hotelManage from "./hotelManage.js"; //活动设置
import takeOut from "./takeOut.js"; //外卖管理
import store from "./store.js"; //店铺管理
import rest from "./rest.js"; //外卖管理
import houseRecommendManage from "./houseRecommendManage.js"; // 推荐房产管理
import homestay from "./homestay.js"; //民宿管理
import statementManage from "./statementManage.js"; //报表管理
import member from "./member.js"; //报表管理
import site from "./site.js"; // 场馆管理
import smartLock from "./smart.js"; //门锁管理
import plate from "./plate.js"; //停车管理
import social from "./social.js"; //社交管理
import community from "./community.js"; //社交管理
import coupon from "./coupon.js"; //社交管理
import fesitival from "./fesitival"; //渔获节
import A4 from "./brands/A4"; //A4
import theatre from "./brands/theatre"; //theatre
import foundation from "./brands/foundation"; //theatre
import memberCard from "./memberCard"; //总会员中心
import vehicle from "./vehicle"; //停车缴费模块
import cruiseManage from "./cruiseManage";
import property from "./property";
import distribution from "./distribution";
import merchantsManage from './merchantsManage'
import progressIndex from './progressIndex'
import tools from "./tools";
// lookfor
import article from "./lookfor/article"; // 文章管理
import userInfo from "./lookfor/user"; // 用户管理
import square from './lookfor/square'; // 广场管理
import sysconfig from './lookfor/sysconfig'; // 广场管理
import globalconfig from './globalconfig'; // 全局参数配置
import boat from './boat'; // 约船管理
// marketing
import marketingHome from './marketing/home'; // 广场管理
//麓豆
import ludou from './ludou'; // 广场管理
// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [{
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: "/home",
    component: () => import("../components/Home.vue"),
    redirect: "",
    name: "Property",
    title: "百悦悦客",
    children: [
      //系统首页
      {
        path: '/dashboard',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */
            '../components/Dashboard.vue'
          ),
        meta: { title: '首页' },
      },
      // 会员设置
      {
        path: "/member",
        component: () => import("../pages/memberManage/member.vue"),
        name: "member",
        redirect: "/memberManage",
        title: "会员管理",
        children: member
      },
      // 系统设置
      {
        path: "/base",
        component: () => import("../pages/system/system.vue"),
        name: "system",
        redirect: "/organization",
        title: "系统设置",
        children: system
      },
      // 用户管理
      {
        path: "/userManage",
        component: () => import("../pages/userManage/userManage.vue"),
        name: "/UserManage",
        redirect: "/userMesManage",
        title: "用户管理",
        children: user
      },
      // 班车管理
      {
        path: "/busManage",
        component: () => import("../pages/busManage/busManage.vue"),
        name: "BusManage",
        redirect: "/lineManage",
        title: "班车管理",
        children: bus
      },
      // 商城管理
      {
        path: "/shoppingMall",
        component: () => import("../pages/shoppingMallManage/shoppingMall.vue"),
        name: "ShoppingMall",
        redirect: "/mallClassifyManage",
        title: "商城管理",
        children: shop
      },
      // 运营管理
      {
        path: "/operManage",
        component: () => import("../pages/operManage/operManage.vue"),
        name: "operManage",
        redirect: "/bannerManage",
        title: "运营管理",
        children: oper
      },
      // 活动管理
      {
        path: "/activitysManage",
        component: () => import("../pages/activity/activitysManage.vue"),
        name: "activitysManage",
        redirect: "/activityClassifyManage",
        title: "活动管理",
        children: activity
      },
      // 酒店管理
      // {
      //   path: "/hotelManage",
      //   component: () => import("../pages/hotelManage/hotelManage.vue"),
      //   name: "hotelManage",
      //   redirect: "/hotel",
      //   title: "酒店管理",
      //   children: hotelManage
      // },
      // 外卖管理
      {
        path: "/takeOut",
        component: () => import("../pages/takeOut/takeOut.vue"),
        name: "takeOut",
        redirect: "/takeOutCate",
        title: "外卖管理",
        children: takeOut
      },
      /**
       * 店铺管理
       * 
       *  */
      {
        path: "/store",
        component: () => import("../pages/store/store.vue"),
        name: "store",
        redirect: "/storeType",
        title: "店铺管理",
        children: store
      },
      // 餐厅管理
      {
        path: "/restManage",
        component: () => import("../pages/restManage/restManage.vue"),
        name: "RestManage",
        redirect: "/diningRoom",
        title: "餐厅管理",
        children: rest
      },
      // 推荐房产管理
      {
        path: "/houseRecommendManage",
        component: () => import("../pages/houseRecommendManage/houseRecommendManage.vue"),
        name: "HouseRecommendManage",
        redirect: "/houseInfoManage",
        title: "推荐房产管理",
        children: houseRecommendManage
      },
      // 民宿管理
      {
        path: "/minsuManage",
        component: () => import("../pages/homestay/minsuManage.vue"),
        name: "minsuManage",
        redirect: "/minsuFacilities",
        title: "民宿管理",
        children: homestay
      },
      // 报表管理
      {
        path: "/statementManage",
        component: () => import("../pages/statementManage/statementManage.vue"),
        name: "StatementManage",
        redirect: "/activityJionStatement",
        title: "推荐房产管理",
        children: statementManage
      },
      // 场馆管理
      {
        path: "/siteManage",
        component: () => import("../pages/siteManage/siteManage.vue"),
        name: "siteManage",
        redirect: "/site",
        title: "场馆管理",
        children: site
      },
      // 门禁管理
      {
        path: "/smartLockManage",
        component: () => import("../pages/smartLockManage/smart.vue"),
        name: "SmartLockManage",
        redirect: "/smartLock",
        title: "门禁管理",
        children: smartLock
      },
      // 停车管理
      {
        path: "/plateManage",
        component: () => import("../pages/plateManage/plate.vue"),
        name: "plateManage",
        redirect: "/plateManage",
        title: "停车管理",
        children: plate
      },
      // 社交管理
      {
        path: "/socialManage",
        component: () => import("../pages/socialManage/social.vue"),
        name: "socialManage",
        redirect: "/socialManage",
        title: "社交管理",
        children: social
      },
      {
        path: "/communityManage",
        component: () => import("../components/Layout.vue"),
        name: "communityManage",
        redirect: "/communityManage",
        title: "社群",
        children: community
      },
      {
        path: "/couponManage",
        component: () => import("../components/Layout.vue"),
        name: "couponManage",
        redirect: "/couponManage",
        title: "优惠券管理",
        children: coupon
      },
      {
        path: "/fishFesitivalManage",
        component: () => import("../components/Layout.vue"),
        name: "fishFesitivalManage",
        redirect: "/fishFesitivalManage",
        title: "节日管理",
        children: fesitival
      },
      {
        path: "/distributionManage",
        component: () => import("../components/Layout.vue"),
        name: "distributionManage",
        redirect: "/distributionManage",
        title: "分销中心",
        children: distribution
      },
      {
        path: "/memberManage",
        component: () => import("../components/Layout.vue"),
        name: "memberManage",
        redirect: "/memberManage",
        title: "A4美术馆",
        children: A4
      },
      {
        path: '/theatreManage',
        component: () => import("../components/Layout.vue"),
        name: 'theatreManage',
        redirect: '/theatre/seatManage',
        title: '座位图',
        children: theatre,
      },
      {
        path: '/foundationManage',
        component: () => import("../components/Layout.vue"),
        name: 'foundationManage',
        redirect: '/foundation/introduceManage',
        title: '座位图',
        children: foundation,
      },
      {
        path: '/memberManageAll',
        component: () => import("../components/Layout.vue"),
        name: "memberManageAll",
        redirect: "/memberManageAll",
        title: "会员卡",
        children: memberCard
      },
      {
        path: "/vehicleManage",
        component: () => import("../components/Layout.vue"),
        name: "vehicleManage",
        redirect: "/vehicleManage",
        title: "车辆管理",
        children: vehicle
      },
      {
        path: '/houseRepossession',
        component: () => import("../components/Layout.vue"),
        name: 'houseRepossession',
        redirect: '/houseRepossession',
        title: '收房活动',
        children: property,
      },
      {
        path: "/cruiseProject",
        component: () => import("../components/Layout.vue"),
        name: 'cruiseManage',
        redirect: '/cruiseManage',
        title: '船运项目管理',
        children: cruiseManage,
      },
      {
        path: '/merchants',
        component: () => import("../components/Layout.vue"),
        name: 'merchantsManage',
        redirect: '/merchantsManage',
        title: '入驻商家管理',
        children: merchantsManage,
      },
      {
        path: '/hotelManage',
        component: () => import("../components/Layout.vue"),
        name: "hotelManage",
        redirect: "/hotelManage",
        title: "船运项目管理",
        children: hotelManage
      },
      {
        path: '/merchartsRegiset',
        component: () =>
          import('../pages/merchantsManage/merchantsRegiset.vue'),
        name: 'merchartsRegiset',
        redirect: '/merchantsManage/personalRegist',
        title: '商家注册',
        children: merchartRegist,
      },
      {
        path: '/progressIndex',
        component: () =>
          import('../pages/merchantsManage/registerProgress/progressIndex.vue'),
        name: 'progressIndex',
        redirect: '/progressIndex',
        title: '进度',
        children: progressIndex,
      },
      {
        path: '/tools',
        component: () => import("../components/Layout.vue"),
        name: 'tools',
        redirect: '/tools/checkTicket',
        title: '工具',
        children: tools,
      },
      // lookfor
      {
        path: "/article",
        component: () => import("../components/Layout.vue"),
        name: "article",
        redirect: "/articleCategory",
        title: "文章管理",
        children: article
      },
      {
        path: "/user",
        component: () => import("../components/Layout.vue"),
        name: "user",
        redirect: "/userInfo",
        title: "用户管理",
        children: userInfo
      },
      {
        path: "/square",
        component: () => import("../components/Layout.vue"),
        name: "square",
        redirect: "/circleCheck",
        title: "广场管理",
        children: square
      },
      {
        path: "/boat",
        component: () => import("../components/Layout.vue"),
        name: "boat",
        redirect: "/boat",
        title: "约船管理",
        children: boat
      },
      {
        path: "/globalconfig",
        component: () => import("../components/Layout.vue"),
        name: "globalconfig",
        redirect: "/globalconfig",
        title: "全局参数配置",
        children: globalconfig
      },
      {
        path: "/sysconfig",
        component: () => import("../components/Layout.vue"),
        name: "sysconfig",
        redirect: "/sysconfig",
        title: "lookfor系统参数配置",
        children: sysconfig
      },
      // marketing
      {
        path: "/marketing/homeConfig",
        component: () => import("../components/Layout.vue"),
        name: "marketingHome",
        title: "营销首页",
        children: marketingHome
      },
      // ludou
      {
        path: "/ludou/homePageManage",
        component: () => import("../components/Layout.vue"),
        name: "/ludou",
        title: "麓豆管理",
        children: ludou
      },
    ]
  },

  {
    path: '/cruiseQRUrl/:secretKey',
    component: () =>
      import('../pages/busManage/cruiseQRUrlView/cruiseQRUrl.vue'),
    name: 'cruiseQRUrl',
    title: '单线二维码页面',
    meta: {
      title: '单线二维码页面',
    },
  },
  // 全屏幕铺满布局
  {
    path: "/lookfor/scrollView",
    component: () =>
      import("@/pages/lookfor/square/scrollView.vue"),
    name: "lookforCcrollView",
    title: "帖子大屏滚动",
    meta: {
      title: "帖子大屏滚动"
    }
  },
  {
    path: "/lookfor/scrollView1",
    component: () =>
      import("@/pages/lookfor/square/scrollView1.vue"),
    name: "lookforCcrollView1",
    title: "帖子大屏滚动",
    meta: {
      title: "帖子大屏滚动"
    }
  },
  {
    path: '/theatre/seatMap',
    component: () => import('@/pages/brandsManage/theatre/seatMap.vue'),
    name: 'seatMap',
    title: '座位图',
    meta: {
      title: '座位图',
    },
  },
  {
    path: '/theatre/setSeat',
    component: () => import('@/pages/brandsManage/theatre/setSeat/setSeat.vue'),
    name: 'setSeat',
    title: '设置座位',
    meta: {
      title: '设置座位',
    },
  },
  {
    path: '/QRCodeView/:id/:type',
    component: () => import('../pages/operManage/QRCodeView.vue'),
    name: 'QRCodeView',
    title: '领票二维码',
    meta: {
      title: '领票二维码',
    },
  },
  {
    path: '/mobileMerchantSign',
    component: () =>
      import('../pages/merchantsManage/register/mobileMerchantSign.vue'),
    name: 'mobileMerchantSign',
    title: '商户签约',
    meta: {
      title: '商户签约',
    },
  },
  {
    path: '/login',
    component: () => import('@/pages/login/login.vue'),
    name: 'login',
    title: '设置座位',
  },
];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [...appRouter, page404, page403, page500]

export const routererror = [page404, page403, page500]
